import React from "react";
import { Box, Typography, Chip, Paper } from "@mui/material";

export default function DesignFieldMentorCard({ title, shownIn, onClose }) {
  if (!title && !shownIn?.length) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        position: "fixed",
        right: 24,
        bottom: 24,
        width: 360,
        maxWidth: "calc(100vw - 24px)",
        background: "#fff",
        border: "1px solid #7C3AED",
        borderLeft: "5px solid #7C3AED",
        borderRadius: "8px",
        boxShadow: "0 8px 28px rgba(17,17,17,0.18)",
        p: "14px 16px",
        zIndex: 1500,
      }}
    >
      <Box sx={{ position: "relative" }}>
        {onClose && (
          <Box
            component="button"
            type="button"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: "8px",
              right: "10px",
              border: "none",
              background: "transparent",
              color: "#9CA3AF",
              fontSize: "14px",
              cursor: "pointer",
              p: 0,
              lineHeight: 1,
            }}
          >
            ✕
          </Box>
        )}

        <Box sx={{ display: "flex", gap: 1.25, alignItems: "flex-start" }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              flex: "0 0 20px",
              borderRadius: "50%",
              background: "#EDE9FE",
              color: "#5B21B6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 12,
              fontWeight: 800,
              mt: "1px",
            }}
          >
            i
          </Box>

          <Box sx={{ flex: 1, pr: 2 }}>
            <Typography
              variant="subtitle2"
              sx={{
                m: 0,
                mb: 0.6,
                fontWeight: 800,
                color: "#1F2230",
                lineHeight: 1.4,
                fontSize: 13,
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                m: 0,
                fontSize: 12,
                lineHeight: 1.55,
                color: "#374151",
              }}
            >
              Engineer-validated input — never re-checked for "correctness," only bounds-checked against the client/ASME rulebook. This is not a Bill of Materials line item; it appears verbatim in:
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1.2 }}>
              {shownIn.map((item) => (
                <Chip
                  key={item}
                  label={item}
                  size="small"
                  sx={{
                    background: "#F5F3FF",
                    color: "#4C1D95",
                    border: "1px solid #E9D5FF",
                    borderRadius: "10px",
                    fontWeight: 700,
                    fontSize: 10,
                    height: 22,
                    maxWidth: "100%",
                    ".MuiChip-label": {
                      px: 1,
                    },
                  }}
                />
              ))}
            </Box>

            <Box
              component="span"
              sx={{
                display: "inline-block",
                mt: 1.5,
                fontSize: 9.5,
                fontWeight: 800,
                letterSpacing: ".04em",
                textTransform: "uppercase",
                color: "#5B21B6",
                background: "#EDE9FE",
                borderRadius: 0.75,
                px: 1,
                py: 0.45,
              }}
            >
              Reactive · on click · shown_in only
            </Box>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
